<template>
  <div>
    <section class="content">
      <div class="row">
      </div>
      <!-- /.row -->
    </section>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'CustomerDetails',
  computed: {
    ...mapState([
      'user'
    ])
  },
  data () {
    return {
      userLoanId: this.$route.params.memberLoanId,
      userDisbursementId: this.$route.params.disbursmentId,
      logo: [],
      totalCurrentDueAmt: null,
      emiDate: new Date().toISOString().slice(0, 10),
      form: new Form({
        // errors: []
      }),
      table_search: '',
      paytm: {
        name: '',
        mobile: '',
        email: '',
        amt: 0,
        branch_id: '',
        member_id: '',
        disbursement_id: '',
        collection_center_id: '',
        member_loan_plan_id: '',
        receivedBy: JSON.parse(localStorage.user).id,
        mode: ''
      },
      rowsMemberCollections: [],
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    }
  },
  created () {
    this.loadAdvanceEmiSecurity(this.$route.params.memberLoanId)
  }
}
</script>
<style scoped>
  @media print {
      div { 
        /* float: none !important; */
        /* position: static !important;  */
        display: inline; 
        /* box-sizing: content-box !important; */
      }
      .modal {
          position: absolute;
          left: 0;
          top: 0;
          margin: 0;
          padding: 0;
          overflow: visible!important;
      }
  }
  .content {
    padding: 0px;
  }
  table, tbody, tr, tr, td {
    border: 1px solid black;
  }
  p {
    font-size:18px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 10px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// CustomerDetails.vue?2dafa9f5